





































































































































































































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import WizardService from '@services/Wizard'
import CalendarService from '@services/CalendarService'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import StepNavigation from '@ui/AudienceSetWizard/StepNavigation'
import RadioGroup from '@ui/AudienceSetWizard/components/RadioGroup'
import ItemDistributionTutorialModal from '@ui/AudienceSetWizard/components/tutorials/ItemDistribution/ItemDistributionTutorialModal'

settings =
  name: 'ItemDistributionOverviewStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      Modal,
      StepContainer,
      StepNavigation,
      RadioGroup,
      ItemDistributionTutorialModal,
    }

    data: ->
      display: 'item_distribution'
      quantity: 100

      tableData: [
        {
          label: 'Hand out a Beverage',
          pricingTable: 'drink_distribution',
        },
        {
          label: 'Hand out a Cold Beverage',
          pricingTable: 'addon_serve_cold',
        },
        {
          label: 'Hand out a Snack',
          pricingTable: 'food_distribution',
        },
        {
          label: 'Assemble a Package w/ Food & Promo',
          pricingTable: 'promo_distribution',
        },
      ]

      capacityModal:
        show: false
        audienceAvailability: null
        space: null
        samplingCapacity: null
        dayOptions: null

      tutorialModal:
        show: false

    computed:
      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities
      itemDistributionTableData: ->
        spaces = {}
        for audienceAvailability in @audienceAvailabilities
          { space_keys, venue_key } = audienceAvailability
          for spaceKey in space_keys
            space = spaces[spaceKey]
            space ||= JSON.parse(JSON.stringify(@wizard.lookupSpace(spaceKey)))
            continue unless space.type is 'product_sampling'
            space.audienceAvailabilities ||= {}
            space.audienceAvailabilities[audienceAvailability.key] = audienceAvailability
            space.audienceAvailabilities[audienceAvailability.key].venue = @wizard.lookupVenue venue_key
            space.availabilityImage = audienceAvailability.images[0] if audienceAvailability.images?.length
            space.availabilityImage ||= null
            spaces[spaceKey] = space
        Object.values spaces

      hasSpaces: -> @itemDistributionTableData.length > 0

      optionsForDisplay: ->
        [
          { value: 'item_distribution', label: 'Item Distribution' }
          { value: 'venues', label: 'Venues' }
        ]

      stepNavigationEmptyState: ->
        back: @step.navigation.back
        next: { label: 'Setup Item Distribution', to: 'item-distribution-form' }
        skip: { ...@step.navigation.next, label: 'Skip' }

      dailyCapacityPlaceholder: ->
        sumWeekdaysCapacity = 0
        for key, capacity of (@capacityModal.samplingCapacity || {})
          continue unless key in Object.keys(CalendarService.MAP_RRULE_TO_JS_DAY_OF_WEEK)
          continue if isNaN(parseInt(capacity))
          sumWeekdaysCapacity += parseInt(capacity)
        sumWeekdaysCapacity || ''

    mounted: ->
      @wizard.removeSelectedItemDistributionKey()
      @tutorialModal.show = true unless @hasSpaces

    methods:
      hiEditSpace: (space) ->
        @wizard.setSelectedItemDistributionKey space.key
        @wizard.navToStepName 'item-distribution-form'

      hiRemoveSpace: (space) ->
        for audienceAvailability in @audienceAvailabilities
          audienceAvailability.space_keys = audienceAvailability.space_keys.filter((key) => key isnt space.key)
        @wizard.syncAndSave()

      hiRemoveAudienceAvailabilityFromSpace: (space, audienceAvailability) ->
        audienceAvailability.space_keys = audienceAvailability.space_keys.filter((key) => key isnt space.key)
        @wizard.syncAndSave()

      hiEditCapacity: (audienceAvailability, space) ->
        calendar = @wizard.lookupCalendar audienceAvailability.calendar_key
        dayOptions = CalendarService.dayOptionsForEvents calendar.events
        samplingCapacity = {}

        for option in dayOptions
          day = option.value
          samplingCapacity[day] = audienceAvailability.daily_sampling_capacity[space.segment]?[day]
          samplingCapacity[day] ||= null

        @capacityModal = {
          show: true,
          audienceAvailability,
          space,
          samplingCapacity,
          dayOptions,
        }

      hiCloseCapacityModal: ->
        @closeCapacityModal()

      hiSaveCapacityModal: ->
        { audienceAvailability, space, samplingCapacity } = @capacityModal
        audienceAvailability.daily_sampling_capacity[space.segment] = samplingCapacity
        @closeCapacityModal()
        @wizard.syncAndSave()

      closeCapacityModal: ->
        @capacityModal.show = false

      hasCapacityForAudienceAvailability: (audienceAvailability, space) ->
        audienceAvailability.daily_sampling_capacity[space.segment]?

      formatDay: (day) ->
        @capacityModal.dayOptions.find((option) -> option.value is day).label

      spacePayoutForPricingTable: (table) ->
        pricing = @standardPricingTable()[table]
        payoutInCents = (pricing.price_in_cents - pricing.take_in_cents) * parseInt(@quantity || 0)
        payoutInCents / 100

export default VueOptions.vue settings
